<template>
  <div class="gps-notification-list-container">
    <el-row>
      <el-table
        :data="gpsMessageList"
        :show-header="false"
        :row-style="rowStyle"
        empty-text="無資料"
        v-loading="listLoading"
        style="width: 100%;">
        <el-table-column
          prop="created_at"
          label="建置時間"
          width="150">
          <template slot-scope="scope">
            <span>{{ scope.row | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="標題"
          width="180">
          <template slot-scope="scope">
            <span class="message-title">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="message"
          label="內容"
          min-width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.message }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="lat"
          label="經緯度"
          width="120">
          <template slot-scope="scope">
            <span style="display: block">{{ scope.row.lat }}</span>
            <span>{{ scope.row.lng }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="range"
          label="範圍"
          width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.range + '公尺' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="create-new" @click="createNew()">
      <span class="tfam-new"></span>
    </div>
    <el-dialog
      title="新增推播"
      class="tfam-dialog"
      :visible.sync="gpsDialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="true">
      <el-form v-if="gpsMessageData" :rules="gpsMessageRules" ref="gpsForm" :model="gpsMessageData" label-width="100px" label-position="left">
        <el-form-item label="標題" prop="title">
          <el-input v-model="gpsMessageData.title"></el-input>
        </el-form-item>
        <el-form-item label="內容" prop="message">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5 }"
            v-model="gpsMessageData.message"></el-input>
        </el-form-item>
        <el-form-item label="經度" prop="lat">
          <el-input-number
            v-model="gpsMessageData.lat"
            :controls="false">
          </el-input-number>
        </el-form-item>
        <el-form-item label="緯度" prop="lng">
          <el-input-number
            v-model="gpsMessageData.lng"
            :controls="false">
          </el-input-number>
        </el-form-item>
        <el-form-item label="距離(公尺)" prop="range">
          <el-input-number
            v-model="gpsMessageData.range"
            :controls="false">
          </el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button
            class="tfam-button"
            v-loading.fullscreen.lock="fullLoading"
            plain
            @click="handleSubmitUpdate">儲存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { fetchGPSNotificationList, createGPSNotification } from "../../api/gpsNotification";
  import { parseTime } from '../../utils'

  export default {
    name: "GPSNotificationList",
    components: {
    },
    computed: {
      rowStyle: function () {
        return {
          height: '80px',
          cursor: 'default'
        }
      }
    },
    data() {
      return {
        gpsMessageList: [],
        gpsMessageData: undefined,
        gpsDialogVisible: false,
        listLoading: false,
        fullLoading: false,
        gpsMessageRules: {
          title: [
            {required: true, message: '必填', trigger: 'blur'},
          ],
          message: [
            {required: true, message: '必填', trigger: 'blur'},
          ],
          lat: [
            { type: 'number', required: true, message: '必填', trigger: 'change' }
          ],
          lng: [
            { type: 'number', required: true, message: '必填', trigger: 'change' }
          ],
          range: [
            { type: 'number', required: true, message: '必填', trigger: 'change' }
          ]
        }
      }
    },
    filters: {
      timeFilter: function (row) {
        return parseTime(row['created_at'], '{y}/{m}/{d} {h}:{i}')
      },
    },
    mounted() {
      this.getMessages()
    },
    methods: {
      getMessages() {
        const filter = {
          order: 'created_at DESC',
          limit: 5
        };
        this.listLoading = true;
        fetchGPSNotificationList(filter).then(response => {
          this.listLoading = false;
          this.gpsMessageList = response.data;
        }).catch(err => {
          this.listLoading = false;
        })
      },
      createNew() {
        this.gpsDialogVisible = true;
        this.gpsMessageData = {
          title: undefined,
          message: undefined,
          lat: 25.0724166,
          lng: 121.5226215,
          range: 500
        }
      },
      handleSubmitUpdate() {
        this.$refs['gpsForm'].validate((valid) => {
          if (valid) {
            this.fullLoading = true;
            this.submitUpdate().then(res => {
              this.fullLoading = false;
              this.$refs['gpsForm'].resetFields();
              this.gpsDialogVisible = false;
              this.gpsMessageData = undefined;
              this.gpsMessageList.splice(0, 0, res);
            }).catch(err => {
              this.fullLoading = false;
              console.log(err);
              let message = err;
              if (err.response) {
                message = err.response.data.error.message + '!'
              }
              this.$alert(message, '建立失敗', {
                confirmButtonText: '確定',
                callback: action => {
                }
              });
            })
          } else {
            return false;
          }
        });
      },
      submitUpdate: async function() {
        try {
          const response = await createGPSNotification(this.gpsMessageData);
          return Promise.resolve(response.data);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    }
  }
</script>

<style lang="scss">
  .message-title {
    cursor: pointer;
  }
  .introduction-max-lines {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
</style>

